import { Toaster } from 'react-hot-toast';

/** Centralized toast renderer styled to the CRM tokens. Mount once at app root. */
export function ToastWrapper() {
  return (
    <Toaster
      // Transient feedback belongs low in the corner, away from the topbar
      // controls and the page's primary work area. Incoming notification
      // toasts are capped below, so a long message cannot cover the screen.
      position="bottom-right"
      gutter={8}
      containerStyle={{ bottom: 16, right: 16, zIndex: 90 }}
      toastOptions={{
        duration: 3500,
        style: {
          maxWidth: '320px',
          minWidth: '0',
          padding: '10px 12px',
          borderRadius: '12px',
          background: '#FFFFFF',
          color: '#111827',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          fontSize: '13px',
          fontFamily: 'Poppins, sans-serif',
        },
        success: { iconTheme: { primary: '#10b981', secondary: '#fff' } },
        error: { iconTheme: { primary: '#ef4444', secondary: '#fff' } },
      }}
    />
  );
}
